<template>
  <div class="leftDataComWrap">
    <div class="photoBox">
      <el-image :src="list.img" style="width: 100%; height: 100%" fit="fill">
        <div slot="error" class="image-slot">
          <el-empty description=""></el-empty>
        </div>
      </el-image>
      <div
        class="state"
        :style="{
          background: list.active ? '#27df7c' : '#e7e7e7',
          color: list.active ? '#fff' : '#999',
        }"
      >
        {{ list.active ? "在 线" : "离 线" }}
      </div>
    </div>
    <el-descriptions
      border
      :column="1"
      labelClassName="typeLabelName"
      title="设备数据"
      style="margin-top: 20px"
    >
      <el-descriptions-item
        v-for="(v, i) in loadData"
        :key="i"
        :label="v.display"
      >
        <p style="color: #28CCCB; font-weight: bold">
          {{ v.value }} <span>{{ v.unit }}</span>
        </p>
      </el-descriptions-item>
    </el-descriptions>

    <el-descriptions
      border
      :column="1"
      labelClassName="labelName"
      style="margin-top: 20px"
      size="small"
      title="设备信息"
    >
      <el-descriptions-item label="名称">
        {{ list.name }}
      </el-descriptions-item>
      <el-descriptions-item
        label="运行状态"
        v-if="jumpItem.label == '用能设备'"
      >
        {{ list.state == "1" ? "正常" : list.state == "0" ? "异常" : "" }}
      </el-descriptions-item>
      <el-descriptions-item label="设备类型">
        {{ list.type }}
      </el-descriptions-item>
      <el-descriptions-item label="标签">
        {{ list.label }}
      </el-descriptions-item>
      <el-descriptions-item label="表号">
        {{ list.num }}
      </el-descriptions-item>
      <el-descriptions-item label="编码">
        {{ list.encode }}
      </el-descriptions-item>
      <el-descriptions-item label="所属资产">
        {{ list.upperAssetName }}
      </el-descriptions-item>
      <el-descriptions-item label="所属资产类型">
        {{ list.upperAssetType }}
      </el-descriptions-item>
      <el-descriptions-item label="关联设备">
        {{ list.deviceName }}
      </el-descriptions-item>
      <el-descriptions-item label="安装地点">
        {{ list.location }}
      </el-descriptions-item>
      <el-descriptions-item label="安装时间">
        {{ list.time ? list.time : list.createdTime }}
      </el-descriptions-item>
    </el-descriptions>
  </div>
</template>

<script>
export default {
  props: ["list", "loadData", "jumpItem"],
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.leftDataComWrap {
  width: 100%;
  height: 100%;
  ::v-deep .el-descriptions {
    .labelName {
      width: 30%;
    }
    .typeLabelName {
      width: 34%;
    }
    .el-descriptions__title {
      font-size: 15px;
      font-weight: 600;
    }
  }
  .photoBox {
    width: 70%;
    height: 220px;
    margin: 0 auto;
    background: #f7f7f7;
    border: 1px solid #cccccc;
    border-radius: 20px;
    overflow: hidden;
    position: relative;
    .state {
      position: absolute;
      bottom: 0;
      left: 0;
      height: 40px;
      width: 100%;
      opacity: 0.8;
      background: #27df7c;
      color: #fff;
      @include setFlexCenter;
      font-size: 16px;
      font-weight: 700;
    }
  }
}
</style>